/**
 * Single source of truth for the languages the app supports. Both the
 * header `LanguageSwitcher` and the Profile page's locale field read from
 * here so adding a new language only needs one edit.
 */
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

/**
 * Resolve an i18next language tag (which may be `en-US`, `fr-CA`, etc.) to
 * one of our supported short codes. Defaults to `en` when there's no
 * match — matching v1's fallback.
 */
export const resolveLanguageCode = (lng: string | undefined | null): LanguageCode => {
  if (!lng) return 'en';
  const short = lng.split('-')[0].toLowerCase();
  return short === 'fr' ? 'fr' : 'en';
};
